import BannerContent from './BannerContent';
import BannerSymptomsContent from './BannerSymptomsContent';

const homeBannerTypes = {
  symptoms: BannerSymptomsContent,
  default: BannerContent,
};

export { homeBannerTypes as default };
